// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1WzS5","info":"UpdateTermsInfo_info__1Fqij"};